<div class="card detail">
  <div class="card-body">
    <div class="title text-left">
      <h3 class="card-title">{{ 'Action' | translate }}</h3>
    </div>
    <ul class="list-group overflow-visible">
      <!-- <li class="list-group-item">
        <div class="toggle-container">
          <app-toggle-switch [selected]="isTimeline" (change)="toggleTimeline()"></app-toggle-switch>
          <i class="icon-history"></i>
          <p>{{ 'Map Layer Timeline' | translate }}</p>
        </div>
      </li> -->
      <!-- <li class="list-group-item">
        <a>
          <i class="icon-reference-image"></i>
          <p>{{ 'Reference Image' | translate }}</p>
        </a>
      </li> -->
      <li class="list-group-item lang-container">
        <a>
          <i class="icon-AD1_Splitscreen"></i>
          <p>{{ 'Splitscreen' | translate }}</p>
        </a>
        <div class="card lang">
          <div class="card-body">
            <div class="action-btns">
              <button (click)="onClickAdd()" class="btn btn-sm btn-primary mx-2 mb-1" [disabled]="_maps.length >= MAX_MAP_VIEW_COUNT">{{'Add' | translate}}</button>
              <button (click)="onClickRemove()" class="btn btn-sm btn-primary mx-2 mb-1" [disabled]="_maps.length == 1">{{'Remove' | translate}}</button>
              <button (click)="onClickUnsync()" class="btn btn-sm btn-primary mx-2 mb-1" [disabled]="_maps.length <= 1">{{'UnSync' | translate}}</button>
              <button (click)="onClickResync()" class="btn btn-sm btn-primary mx-2" [disabled]="_maps.length <= 1">{{'ReSync' | translate}}</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>